import { useSelector } from 'react-redux';

import { countrySelector } from '../intl/selectors';
import {
  defaultFeaturesSelector,
  qaFeaturesSelector,
  regionalFeaturesSelector,
  tokenFeaturesSelector,
} from './selectors';
import { AppFeatureName, getIsFeatureVisible } from './utils';

export const useIsFeatureEnabled = (featureName: AppFeatureName) => {
  const countryCode = useSelector(countrySelector);
  const defaultFeatures = useSelector(defaultFeaturesSelector);
  const regionalFeatures = useSelector(regionalFeaturesSelector);
  const tokenFeatures = useSelector(tokenFeaturesSelector);
  const qaFeatures = useSelector(qaFeaturesSelector);

  return getIsFeatureVisible({
    countryCode,
    featureName,
    defaultFeatures,
    regionalFeatures,
    tokenFeatures,
    qaFeatures,
  });
};
